/* less/lib/less/functions/boolean */ function _(require, module, exports) {
    var functionRegistry = require(183) /* ./function-registry */, Anonymous = require(206) /* ../tree/anonymous */, Keyword = require(226) /* ../tree/keyword */;
    functionRegistry.addMultiple({
        boolean: function (condition) {
            return condition ? Keyword.True : Keyword.False;
        },
        'if': function (condition, trueValue, falseValue) {
            return condition ? trueValue
                : (falseValue || new Anonymous);
        }
    });
}
